import React, { useEffect, useState } from 'react';
import { Card, Form, Input, Button, Checkbox, Row, Col, Alert } from 'antd';
import { useFormik } from 'formik';
import styled from 'styled-components';
import { useDispatch } from 'react-redux';
import { createSelector } from 'reselect';
import { useSelector } from 'react-redux';
import * as Yup from 'yup';
import { Link } from 'react-router-dom';

import usecustomStyles from '../../Common/customStyles';
import ParticleAuth from '../../Common/ParticleAuth';
import withRouter from '../../Common/withRouter';
import { loginUser, resetLoginFlag } from '../../slices/thunk';
import '../../assets/scss/login.scss';
import {longImagePath} from '../../assets/images/logo-sichuan';
import { color } from 'echarts';

const customStyles = usecustomStyles();

const StyleWrapper = styled.div`

`;
// const StyleWrapper = styled.div`
//     background: ${({ theme }) => theme.token.authbg};
// `;

const StyleTitle = styled.div`
    font-size: 40px;
    letter-spacing: 1px;
    color: rgb(255,255,255);
    position: absolute;
    top:-14%;
    left:34%;
    z-index: 999;
`;

const Signin = props => {
    // page title
    document.title = '登录' + process.env.REACT_APP_PAGE_TITLE;

    const dispatch = useDispatch();
    const selectAccountAndLogin = createSelector(
        state => state.Account,
        state => state.Login,
        (account, login) => ({
            user: account.user,
            error: login.error,
            loading: login.loading,
            errorMsg: login.errorMsg
        })
    );

    const { user, error, loading, errorMsg } = useSelector(selectAccountAndLogin);
    const [isLoading, setLoading] = useState(loading);
    const [userLogin, setUserLogin] = useState({});

    useEffect(() => {
        if (user && user) {
            const updatedUserData = user.username;
            const updatedUserPassword = user.password;
            setUserLogin({
                username: updatedUserData,
                password: updatedUserPassword
            });
        }
    }, [user]);

    const validation = useFormik({
        // enableReinitialize : use this flag when initial values needs to be changed
        enableReinitialize: true,
        initialValues: {
            username: userLogin.username || '',
            password: userLogin.password || ''
        },
        validationSchema: Yup.object({
            username: Yup.string().required('请输入用户名'),
            password: Yup.string().required('请输入密码')
        }),
        onSubmit: values => {
            setLoading(true);
            dispatch(loginUser(values, props.router.navigate))
            .then(() => {
                  // 请求完成后，无论成功还是失败，都将 isLoading 重置为 false
                  setLoading(false);
              });
            // setLoading(true);
        }
    });

    useEffect(() => {
        if (errorMsg) {
            setTimeout(() => {
                dispatch(resetLoginFlag());
            }, 3000);
        }
    }, [dispatch, errorMsg]);

    return (
        <React.Fragment>
            <StyleWrapper className="auth-page-wrapper">
                <video autoPlay muted loop className="login-background-video">
                    <source src="https://gw.alipayobjects.com/v/huamei_gcee1x/afts/video/jXRBRK_VAwoAAAAAAAAAAAAAK4eUAQBr" type="video/mp4" />
                </video>
                <Row justify="center" align="middle" style={{ minHeight: '100vh' }}>
                    <Col xs={24} lg={14}>
                        <StyleTitle>智能安全终端管理平台</StyleTitle>
                        <Card>
                            <Row gutter={[16, 24]}>
                                <ParticleAuth />
                                <Col xs={24} lg={12}>
                                    <div style={{ border: '0px' }}>
                                        <div className="text-center" style={{ margin: '20px' }}>
                                            <h5 style={{ fontSize: '20px', color: customStyles.colorPrimary }}>欢迎回来!</h5>
                                            <p></p>
                                        </div>
                                        <div style={{ marginTop: '30px', padding: '40px' }}>
                                            {/* {error && error ? <Alert type="error" message={error}></Alert> : null} */}
                                            {error && error ?<p style={{ color: 'red' }}>{error}</p> : null} 
                                            <Form
                                                onSubmit={e => {
                                                    e.preventDefault();
                                                    validation.handleSubmit();
                                                    return false;
                                                }}
                                            >
                                                <div>
                                                    <label style={{ display: 'block', marginBottom: '4px' }}>用户名</label>
                                                    <Input
                                                        name="username"
                                                        style={{ margin: '10px 0px', boxShadow: 'none', outline: 'none' }}
                                                        type="username"
                                                        value={validation.values.username || ''}
                                                        onChange={validation.handleChange}
                                                        onBlur={validation.handleBlur}
                                                        onInvalid={validation.touched.username && validation.errors.username ? validation.touched.username : undefined}
                                                        status={validation.touched.username && validation.errors.username ? 'error' : true}
                                                    />
                                                    {validation.touched.username && validation.errors.username && <p style={{ color: customStyles.colorDanger }}>{validation.errors.username}</p>}
                                                </div>
                                                <div>
                                                    <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                                        <label style={{ display: 'block', marginBottom: '4px' }}>密码</label>
                                                        <Link to="/forgot-password" style={{ fontSize: '11px' }}>
                                                            忘记密码?
                                                        </Link>
                                                    </div>
                                                    <Input.Password
                                                        name="password"
                                                        value={validation.values.password || ''}
                                                        onChange={validation.handleChange}
                                                        style={{ boxShadow: 'none', outline: 'none' }}
                                                        onBlur={validation.handleBlur}
                                                        onInvalid={validation.touched.password && validation.errors.password ? validation.touched.password : undefined}
                                                        status={validation.touched.password && validation.errors.password ? 'error' : true}
                                                    />
                                                    {validation.touched.password && validation.errors.password && <p style={{ color: customStyles.colorDanger }}>{validation.errors.password}</p>}
                                                </div>

                                                <Form.Item>
                                                    <Form.Item name="remember" valuePropName="checked" noStyle>
                                                        <Checkbox style={{ marginTop: '10px' }}>记住我</Checkbox>
                                                    </Form.Item>
                                                </Form.Item>
                                                <div>
                                                    <Button
                                                        htmlType="submit"
                                                        type="primary"
                                                        onClick={e => {
                                                            e.preventDefault();
                                                            validation.handleSubmit();
                                                            return false;
                                                        }}
                                                        style={{ width: '100%' }}
                                                        loading={isLoading}
                                                    >
                                                        登{'   '}录
                                                    </Button>
                                                </div>
                                            </Form>
                                            <div style={{ marginTop: '50px' }} className="text-center"></div>
                                        </div>
                                        <div className="text-center" style={{ fontSize: '14px', color: '#616161', display: 'flex', justifyContent: 'center', width: '100%', whiteSpace: 'nowrap', zIndex: '9' }}>
                                            <img style={{ border: 0 }} src={longImagePath} alt='' />
                                            <a href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11040102700068" style={{ marginRight: '16px', marginBottom: '0', textDecoration: 'none', color: 'inherit' }}>川公网安备51010702043115号</a>
                                            <a href="http://beian.miit.gov.cn/" style={{ marginRight: '16px', marginBottom: '0', textDecoration: 'none', color: 'inherit' }}>蜀ICP备2024085151</a>
                                        </div>
                                    </div>
                                </Col>
                            </Row>
                        </Card>
                    </Col>
                </Row>

            </StyleWrapper>
        </React.Fragment>
    );
};

export default withRouter(Signin);
